import(/* webpackMode: "eager", webpackExports: ["ApplyTabs"] */ "/vercel/path0/apps/lander/src/app/(site)/zero-to-hero/apply/ApplyTabs.jsx");
